import { Component, forwardRef, Input, OnDestroy, ViewChild } from '@angular/core';
import { ControlContainer, ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { TagebuchNummerSearchRequestMeta } from '../../../core/gb-api';
import { GbGemeindeSearchMode } from '../gb-gemeinde/gbGemeindeSearchMode';
import { GbAmtComponent } from '../gb-amt/gb-amt.component';
import { TagebuchValidatorDirective } from '../../directives/tagebuch-validator.directive';
import { CapFormRowDirective } from '../../form-control/cap-form-row.directive';
import { CapFormControlComponent } from '../../form-control/form-control.component';
import { MetaDisablerDirective } from '../../directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../directives/meta-validator.directive';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-tagebuch-nummer',
  templateUrl: './tagebuch-nummer.component.html',
  styleUrls: ['./tagebuch-nummer.component.scss'],
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => TagebuchNummerComponent), multi: true }],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  imports: [
    TagebuchValidatorDirective,
    CapFormRowDirective,
    CapFormControlComponent,
    GbAmtComponent,
    FormsModule,
    MetaDisablerDirective,
    MetaValidatorDirective,
    TranslatePipe
  ]
})
export class TagebuchNummerComponent implements OnDestroy, ControlValueAccessor {
  @Input()
  searchMode: GbGemeindeSearchMode;

  @ViewChild(GbAmtComponent, { static: false })
  private gbAmtComponent: GbAmtComponent;

  @Input()
  hasfocus = false;

  @Input() name: string;

  @Input() heading: string;

  @Input() hasRightMassenabfrage = true;

  model: TagebuchNummerSearchRequestMeta = {};

  private _subscription: Subscription;

  onTouched: any = () => {};
  onChange: any = () => {};

  writeValue(obj: any): void {
    this.model = obj;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  ngOnDestroy(): void {
    this._subscription?.unsubscribe();
  }

  onReset() {
    this.gbAmtComponent.onClear();
  }

  public focus() {
    this.gbAmtComponent.focus();
  }
}
